<template>
    <div
        ref="queueContainer"
        class="sidebarContainer"
        style=""
    >
      <div style="border: 0px solid white; height: 25%; display: flex; align-items: center; justify-content: center;">
        <div style="width: 100%;">
          <p style="font-size: 300%; color: white; font-weight: bold; font-family: 'Ubuntu', sans-serif;">@12</p>
          <div class="glass search-container">
            <v-icon size="large" class="search-icon">
              mdi-magnify
            </v-icon>

            <v-text-field
              class="search-field"
              variant="plain"
              density="compact"
              hide-details
              placeholder="search..."
              v-model="searchQuery"
              @keyup.enter="searchSong(searchQuery)"
            />
          </div>
        </div>
      </div>

      <div v-if="queueStore.queue.length && queueStore.isQueueVisible" style="height: 75%; width: 100%;">
        <queue-component></queue-component>
      </div>
      <div v-else style="border: 0px solid white; width: 100%; height: 75%; display: flex; flex-direction: column; justify-content: space-between;">
        <div v-if="queueStore.queue.length" class="glass queueBtn" @click="queueStore.isQueueVisible = true">
          <p style="color: white; text-align: center; font-size: small; pointer-events: none;">Queue</p>
        </div>
        <div v-if="feedStore.quickPicks.length" :style="{height: queueStore.queue.length ? '90%' : '100%', border:'0px solid white', display:'flex', flexDirection:'column', justifyContent:'space-between'}">
          <p style="font-size: 150%; color: white; font-weight: bold; text-align: left; margin-left: 1vw; height: 7%;">Quick Picks</p>
          <div style="border: 0px solid yellow;  overflow-y: scroll; height: 91%;">
            <div v-for="(item, index) in feedStore.quickPicks" :key="item.videoId" style="border: 0px solid white; cursor: pointer;" @click="playTrack(item)">
              <div style="display: flex; height: 9vh; width: 95%; border-radius: 15px; margin: auto; margin-bottom: 1vh; justify-content: left;" class="glass">
                <p style="color: white; font-size: large; font-weight: bold; margin-left: 1vw; margin-right: 1vw;">{{ index > 8 ? index+1 : '0'+(index+1) }}</p>
                <div style="width: 45px; height: 45px; position: relative; overflow: hidden; border-radius: 10px;">
                  <img class="thumbnail" style="height: 140%;" :src="item.thumbnail?.standard.url || `https://ui-avatars.com/api/?name=${item.title}&background=random`" alt="">
                </div>
                <p style="width: 50%; border: 0px solid white; text-align: left; font-size: small; margin-left: 1vw;">{{ item.title.split("(")[0].split("|")[0].length > 30 ? item.title.split("(")[0].split("|")[0].substring(0,30)+'...' : item.title.split("(")[0].split("|")[0] }}</p>
              </div>
            </div>
          </div>
        </div>
        <v-skeleton-loader v-else class="custom-speed" height="100%" color="#80808027" width="95%" style="margin: auto;"></v-skeleton-loader>
      </div>
    </div>
</template>

<script>

// import { EventBus } from '@/eventBus';
import { useToast } from 'vue-toastification';
import { useQueueStore } from '../stores/queue';
import { useLyricsStore } from '../stores/lyrics';
import QueueComponent from './queueComponent.vue';
import { EventBus } from '../eventBus.js';
import { useFeedStore } from '../stores/feed.js';

export default {
  name: "ArtistFeedComponent",

  components:{
    QueueComponent
  },

  setup() {
    const queueStore = useQueueStore();
    const lyricsStore = useLyricsStore();
    const feedStore = useFeedStore();
    return { queueStore, lyricsStore, feedStore };
  },

  data() {
    return {
        toast: useToast(),
        artists: [
            {
                name: "Alka Yagnik",
                id: "UCLH5ojAg1XIyxcOCazK4n-Q",
                thumbnail: "https://lh3.googleusercontent.com/_wPXKRCH5rAX8AK1kJZ1bNhSpNyyEgBRNmREdPmLbvTy3sX_ldiKMRYFc5uChygV_KRx_SDrH1KgUifk=w175-h175-p"
            },
            {
                name: "Udit Narayan",
                id: "UCrYczeBh8tcxLLAgn8m2wWQ",
                thumbnail: "https://lh3.googleusercontent.com/coesV4OVEVkua3_wJG-2BVvTc95yHF9sS1W6mOAtl4-vvTjQb250Hy_nVlfvudmEugb7_k05vhY9aJm4=w80-h80-p"
            },
            {
                name: "Arijit Singh",
                id: "UCtFOW7jJXChfFNoucRFqRmw",
                thumbnail: "https://lh3.googleusercontent.com/W_yOqnKSDYyeVOY_AsXhuAtb6rW3vCL3GtJ9DA1GxWOrJfyeSOqzvTv_TkFHijdkVPXWutASBlRFPg=w80-h80-p"
            },
            {
                name: "Kumar Sanu",
                id: "UCyhq3s9caQkOl-lY1laVC5w",
                thumbnail: "https://lh3.googleusercontent.com/cPvYaP4ByG-i7fUE-dKrjMgaNL8v3hC93ErP6meKnltvRuzxo-DINLQkTtvjfC6hVnzRMlnJEb9n3uM=w80-h80-p"
            },
            {
                name: "Shreya Ghoshal",
                id: "UCcL78rRNuUQ8t7Dx4CLmRqA",
                thumbnail: "https://lh3.googleusercontent.com/a-/ALV-UjVooPUaK5s24CNCmDjwzaeoV6C8EhKA-BIFwygOGaF_VHDiBd0=w80-h80-p"
            },
            {
              name: "Sonu Nigam",
              id: "UCDYFISYJx2tSc6cyhvx0N5Q",
              thumbnail: "https://lh3.googleusercontent.com/iWH_XSIO8yZvIqz8vxkwC9BjzGM4giAhR69Z6LZ0t8Rp79ASNFVwpwHZWOyyo94B_jsXl8HtFueMgMA=w80-h80-p"
            },
            {
              name: "Lata Mangeshkar",
              id: "UCOq_phR9Fi_eUwNweVXlQIw",
              thumbnail: "https://lh3.googleusercontent.com/aOdQY2mAYeneChSYXR-XM8Jmar12sSGavWQjNXJcoQnoxe6iri4ju4GuJKpyxDoCk3813ROgTBD72Gg=w80-h80-p"
            },
            {
              name: "Pritam",
              id: "UCFrjzbol2Zy-FaKaCIKIDVA",
              thumbnail: "https://yt3.googleusercontent.com/sjGMYJQ1J3FZEIBsMYUztMjjYOM4-NJ24CjmIHqxTWCxAM1YgjL-d_17u7_PRhTouOwwAjbu-2x5S6I=w80-h80-p"
            },
            {
              name: "Sunidhi Chauhan",
              id: "UCOy7uPsjass2DCY4a_UUp-Q",
              thumbnail: "https://lh3.googleusercontent.com/_c102EBASHERqDnrU32iygceCB0ItZy5PSeR6rvnKEusmQWNZhZRcp_xdlZHS578a82QVSPKfOyrzn8=w80-h80-p"
            },
            {
              name: "Khesari Lal Yadav",
              id: "UCJfeUWkrU4JwIJfP-usd-_w",
              thumbnail: "https://lh3.googleusercontent.com/rdhk-_2UHeXOqem15INGphwJQBGYj3JkeckFYUZVPoL5aVPm3TS730uKayljYiuahRXolePwSsyWO8KI=w80-h80-p"
            },
            {
              name: "Masoom Sharma",
              id: "UCTyJBpNC7mdjCT5aF5oulww",
              thumbnail: "https://yt3.googleusercontent.com/7qK3_qtRlpQ4zmpSNp3cneXzIv0JxO1jW3xd5ZPbI2tLkIruF4IQ-95-YI3zs6xYNVRDvbG9U3BDlTY=w80-h80-p"
            },
            {
              name: "Yo Yo Honey Singh",
              id: "UC1KonH1j8WMhc5cT6Bp7NtA",
              thumbnail: "https://lh3.googleusercontent.com/Ss_NEfGmfpwXCiuoNxiKxWAoU3M484SwZ4UmahATX7KwOqIaoqTyESuNyZV3fzJm25bmjtfSUxsIFI8=w80-h80-p"
            }
        ],
        prodUrl: process.env.VUE_APP_PROD_URL,
        quickPicks : this.feedStore.quickPicks,
        searchQuery: null
    };
  },

  computed: {
    artistId(){
      return this.$route.params.artistId;
    }
  },

  methods: {
    searchSong(query){
      if(!query || !query.length) return;
      this.$router.push({ path: '/search', query: { q: query } });
    },
    playTrack(track){
        const videoId = track.snippet?.resourceId?.videoId || track.videoId || track.id;
        if(this.queueStore.queue[this.queueStore.isPlayingIndex]?.id == videoId){
            this.queueStore.isPlaying ? EventBus.emit('pause'):EventBus.emit('play');
        } else if (this.queueStore.queue[this.queueStore.isPlayingIndex]?.id !== videoId) {
            this.queueStore.emptyQueue();
            this.queueStore.play();
            this.queueStore.isPlayingIndex = 0;
            EventBus.emit('play_track', { ...track, id: videoId, title: track.title });
        }
    },
  },
  activated(){

  },
  mounted() {
    if(!this.quickPicks.length){
      this.feedStore.fetchTopSongs();
    }
    EventBus.on('searchQuery', (query) => {
      this.searchQuery = query
    })
  },

  beforeUnmount() {
    
  },

  watch:{
    
  }
};
</script>

<style scoped>
.sidebarContainer{
  width: 95%;
  height: 98vh;
  overflow-y: hidden;
  scrollbar-width: none;
  border: 0px solid;
  -ms-overflow-style: none;
  z-index: 1;
  scrollbar-width: none;

  border-radius: 10px;

  background: rgba(0, 0, 0, 0.35);
}

.v-field {
  padding: 0;
}

.v-field__input {
  padding: 0;
}

.queueBtn{
  width: 90%;
  height: 7%;

  margin: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid white;
  border-radius: 10px;

  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;

  color: white;

  transition:
      background 0.25s ease,
      border-color 0.25s ease;

  cursor: pointer;
}

.queueBtn:hover {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.2);
}

.search-container {
  width: 80%;
  height: 50px;

  margin: auto;
  margin-top: 1vh;
  display: flex;
  align-items: center;

  border: 0px solid white;
  border-radius: 20px;
}

.search-icon {
  margin-left: 20px;
  flex-shrink: 0;
}

.search-field {
  flex: 1;
  margin-left: 8px;
}

.search-field :deep(.v-field) {
  min-height: 0;
  height: 40px;
  padding: 0;
}

.search-field :deep(.v-field__input) {
  min-height: 0;
  height: 40px;
  padding: 0 8px;

  display: flex;
  align-items: center;
}

.search-field :deep(input) {
  padding: 0;
}

::-webkit-scrollbar {
    display: none;
}

.artistCard{
  display: flex;
  padding: 3%;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 50px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  color: white;
  transition: background 0.3s ease;
}

.artistCard:hover {
  background: rgba(255, 255, 255, 0.1);
}

.highlight{
  border: 0px solid white;
}

@media screen and (max-width: 675px) {
  .queueContainer {
    width: 100%;
    height: 80vh;
    z-index: 2;
    background-color: #000;
  }
  
}
</style>